// @flow
import styled from '@emotion/styled'
import * as React from 'react'

import { colors } from '@toggl/style'

import { useScript } from './hooks/useScript'
import { HubSpotForm } from './HubSpotForm'

function useStylesheet(href: string) {
  React.useEffect(() => {
    const head = document.head
    if (!head) return
    const link = document.createElement('link')
    link.href = href
    link.rel = 'stylesheet'
    link.type = 'text/css'

    head.appendChild(link)
    return () => {
      head.removeChild(link)
    }
  }, [href])
}

declare var hbspt: any
declare var Calendly: any

const DEMO_REQUEST_FORM_ID = 'c2e7afd5-ee23-4f9e-9f79-5195db280557'

export default function DemoRequestForm({
  textColor,
  bgColor,
}: {
  textColor?: string,
  bgColor?: string,
}) {
  useStylesheet('https://assets.calendly.com/assets/external/widget.css')
  useScript(
    'https://assets.calendly.com/assets/external/forms.js',
    React.useCallback(() => {
      // eslint-disable-next-line no-undef
      Calendly.initHubspotForm({
        id: DEMO_REQUEST_FORM_ID,
        url:
          'https://calendly.com/api/form_builder/forms/5564d99f-517c-42e5-b36a-a1c0d5fa0e27/submissions',
      })
    }, [])
  )
  return (
    <Root bgColor={bgColor} textColor={textColor}>
      <HubSpotForm formId={DEMO_REQUEST_FORM_ID} />
    </Root>
  )
}

const Root: React.ComponentType<any> = styled.div`
  background: ${(p) => p.bgColor || colors.peach100};
  padding: 20px 30px 30px;
  min-height: 800px;
  border-radius: 8px;
`
